import { CLICK_ID_FIELDS, MARKETING_ATTRIBUTION_LIMITS, UTM_URL_PARAM_ENTRIES } from '../types/MarketingAttribution.js';

/**
 * Pure URL extraction functions for marketing attribution params.
 * No React, no cookies, no side effects — just URL parsing.
 *
 * Extracted from Carthage's useMarketingParams.ts so both Carthage and the
 * SDK checkout module consume the same extraction logic.
 */
const { CLICK_ID_MAX, UTM_MAX } = MARKETING_ATTRIBUTION_LIMITS;
/** Extract click IDs from URL search params. */
function extractClickIds(params) {
    const clickIds = {};
    for (const param of CLICK_ID_FIELDS) {
        const value = params.get(param);
        if (value) {
            clickIds[param] = value.slice(0, CLICK_ID_MAX);
        }
    }
    return clickIds;
}
/** Extract UTM params from URL search params. */
function extractUtmParams(params) {
    const utm = {};
    for (const [urlParam, camelKey] of UTM_URL_PARAM_ENTRIES) {
        const value = params.get(urlParam);
        if (value) {
            utm[camelKey] = value.slice(0, UTM_MAX);
        }
    }
    return utm;
}
/** Returns true when at least one field in the object has a truthy value. */
function hasAnyValues(obj) {
    return Object.values(obj).some(Boolean);
}
/**
 * Parse the GA4 client ID out of a raw `_ga` cookie value.
 * Format: `GA<container>.<n>.<clientId>`, where the client ID is the last two
 * dot-separated segments (`GA1.1.1234567890.1700000000` → `1234567890.1700000000`).
 * Returns null when the value is absent, has fewer than four segments, or either
 * trailing segment is empty (e.g. `GA1.1.123.`), so malformed cookies don't
 * produce a junk identifier.
 */
function parseGaClientId(rawGa) {
    if (!rawGa)
        return null;
    const parts = rawGa.split('.');
    if (parts.length < 4)
        return null;
    const visitorId = parts[parts.length - 2];
    const timestamp = parts[parts.length - 1];
    if (!visitorId || !timestamp)
        return null;
    return `${visitorId}.${timestamp}`;
}

export { extractClickIds, extractUtmParams, hasAnyValues, parseGaClientId };
//# sourceMappingURL=marketing-params.js.map
